import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IAppState } from "./types";

export const appInitalState: IAppState = {
    isLoading: false
};

const appSlice = createSlice({
  name: "app",
  initialState: appInitalState,
  reducers: {
    setIsAppLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    }
  }
});

export const { setIsAppLoading } = appSlice.actions;
export default appSlice.reducer;
